import React from "react";
import "./Intro.css";
import Me from "../../imgs/me.png"; 
import Vecco from "../../imgs/vec.jpg";

const Intro = () => {
  return (
    <div className="intro">
      <div className="i-left">
        <div className="i-name">
          <span>HELLO ! I Am </span>
          <span>Neetu Kumari </span>      
          <span style={{ fontFamily: "cursive", color: "#439ce3", fontSize: "smaller" }}>
            Creative, Passionate, Focused
          </span>
          <br></br>
          
          <span style={{ fontFamily: "system-ui" }}>
            Currently I'm a self-employed web developer, who works on many diverse projects.
          </span>
          <br></br>
        </div>
        <button className="button i-button">Hire me</button>
      </div>
      <div className="i-right">
        <img src={Vecco} alt="" />
        <img src={Me} alt="" />
      </div>
    </div>
  );
};

export default Intro;
